import { render, staticRenderFns } from "./autosizelabel.vue?vue&type=template&id=6646c687&scoped=true&"
import script from "./autosizelabel.vue?vue&type=script&lang=js&"
export * from "./autosizelabel.vue?vue&type=script&lang=js&"
import style0 from "./autosizelabel.vue?vue&type=style&index=0&id=6646c687&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6646c687",
  null
  
)

export default component.exports